import _objectWithoutProperties from "/var/www/pontevedra4picosroad.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "/var/www/pontevedra4picosroad.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import * as React from "react";
import { LightboxDefaultProps } from "./props.js";
import { CarouselModule, ControllerModule, CoreModule, createNode, NavigationModule, NoScrollModule, PortalModule, ToolbarModule, withPlugins } from "./core/index.js";
var renderNode = function renderNode(node, props) {
  var _a;
  return React.createElement(node.module.component, _objectSpread({
    key: node.module.name
  }, props), (_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function (child) {
    return renderNode(child, props);
  }));
};
export var Lightbox = function Lightbox(props) {
  var carousel = props.carousel,
    animation = props.animation,
    render = props.render,
    toolbar = props.toolbar,
    controller = props.controller,
    on = props.on,
    plugins = props.plugins,
    restProps = _objectWithoutProperties(props, ["carousel", "animation", "render", "toolbar", "controller", "on", "plugins"]);
  var defaultCarousel = LightboxDefaultProps.carousel,
    defaultAnimation = LightboxDefaultProps.animation,
    defaultRender = LightboxDefaultProps.render,
    defaultToolbar = LightboxDefaultProps.toolbar,
    defaultController = LightboxDefaultProps.controller,
    defaultOn = LightboxDefaultProps.on,
    restDefaultProps = _objectWithoutProperties(LightboxDefaultProps, ["carousel", "animation", "render", "toolbar", "controller", "on"]);
  var _withPlugins = withPlugins([createNode(PortalModule, [createNode(NoScrollModule, [createNode(ControllerModule, [createNode(CarouselModule), createNode(ToolbarModule), createNode(NavigationModule)])])])], plugins),
    config = _withPlugins.config,
    augmentation = _withPlugins.augmentation;
  var augmentedProps = augmentation(_objectSpread({
    carousel: _objectSpread({}, defaultCarousel, carousel),
    animation: _objectSpread({}, defaultAnimation, animation),
    render: _objectSpread({}, defaultRender, render),
    toolbar: _objectSpread({}, defaultToolbar, toolbar),
    controller: _objectSpread({}, defaultController, controller),
    on: _objectSpread({}, defaultOn, on)
  }, restDefaultProps, restProps));
  if (!augmentedProps.open) return null;
  return React.createElement(React.Fragment, null, renderNode(createNode(CoreModule, config), augmentedProps));
};